import { Container, ServicesList, HeaderPages } from '../components';

import styled from 'styled-components';

const Services = () => {
  return (
    <Container>
      <ServicesContant>
        <HeaderPages title="My Services" shadow={'My'} />
        <ServicesContant>
          <ServicesList />
        </ServicesContant>
      </ServicesContant>
    </Container>
  );
};

export default Services;
const ServicesContant = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 8rem;
  align-items: center;
  width: 95%;
  justify-content: center;
  height: 100%;
`;
